module.exports = __webpack_public_path__ + "static/media/loading.c5590569.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loading.svg
// module id = 342
// module chunks = 0